'use strict';

angular.module('amexReconciliationApp')
  .filter('bcaAccountsFilter', function () {

    return function(collection, searchTerm) {
      var filters = [
        function (bcaAccount) {
          return _.get(bcaAccount, 'bcaNumber', '');
        },
        function (bcaAccount) {
          return _.get(bcaAccount, 'siteName', '');
        },
        function (bcaAccount) {
          return _.get(bcaAccount, 'bcaName', '');
        },
        function (bcaAccount) {
          return _.get(bcaAccount, 'description', '');
        }
      ];

      return _.filter(collection, function (bcaAcccount) {
        return _.some(filters, function (filter) {
          var filtered = _.toUpper(filter(bcaAcccount));
          return filtered.indexOf(_.toUpper(searchTerm)) > -1;
        });
      });
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/bcaAccountsFilter.js
// module id = 551
// module chunks = 0